// ** Redux Imports
import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { authReducer } from '../../modules/account/login/reducers/authReducer';
import { authSaga } from '../../modules/account/login/sagas/authSaga';
import { accountReducer } from '../../modules/account/register/reducers/accountReducer';
import { accountSaga } from '../../modules/account/register/sagas/accountSaga';
import { analysisHistoryReducer } from '../../modules/analysis/history/reducers/analysisHitoryReducer';
import { analysisHistorySaga } from '../../modules/analysis/history/sagas/analysisHistorySaga';
import { analysisSimulatorReducer } from '../../modules/analysis/simulation/reducers/analysisSimulatorReducer';
import { analysisSimulatorSaga } from '../../modules/analysis/simulation/sagas/analysisSimulatorSaga';
import { dronReducer } from '../../modules/basis/dron/reducers/basisDronReducer';
import { dronSaga } from '../../modules/basis/dron/sagas/basisDronSaga';
import { groupReducer } from '../../modules/basis/group/reducers/basisGroupReducer';
import { basGroupSaga } from '../../modules/basis/group/sagas/basisGroupSaga';
import { messageReducer } from '../../modules/comn/message/reducers/comnMessageReducer';
import {
  mypageReducer,
  userPwReducer
} from '../../modules/account/login/reducers/authReducer';
import { findSaga } from '../../modules/account/find/sagas/findSaga';
import { findAccountReducer } from '../../modules/account/find/reducers/findReducer';

import {
  controlGpDtlReducer,
  controlGpHisReducer,
  controlGpReducer,
  // controlGroupAuthReducer,
  controlGpFltPlanReducer,
  controlGpSaga,
  ControlGpState,
  controlGpLogReducer,
  controlGpCountReducer
} from '../../modules/control/gp';
import controlMapReducer from '../../modules/control/map/reducers/controlMapReducer';
import { mainDahReducer } from '../../modules/main/dash/reducers/mainDashReducer';
import { mainDashSaga } from '../../modules/main/dash/sagas/mainDashSaga';
import { menuReducer } from '../../modules/menu/reducers/menuReducer';
// ** Reducers Imports
import auth from './auth';
import layout from './layout';
import navbar from './navbar';
import { loadingReducer } from './loading';

import { flightReducer } from '../../modules/basis/flight/reducers/basisFlightReducer';
import { flightSaga } from '../../modules/basis/flight/sagas/basisFlightSaga';

export interface StoreState {
  controlGpState: ControlGpState;
}

export function* saga() {
  yield all([fork(mainDashSaga)]);
  yield all([fork(controlGpSaga)]);
  yield all([fork(analysisHistorySaga)]);
  yield all([fork(accountSaga)]);
  yield all([fork(authSaga)]);
  yield all([fork(basGroupSaga)]);
  yield all([fork(dronSaga)]);
  yield all([fork(analysisSimulatorSaga)]);
  yield all([fork(flightSaga)]);
  yield all([fork(findSaga)]);
}

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  controlMapReducer,
  loadingReducer,
  mainDashState: mainDahReducer,
  messageState: messageReducer,
  groupState: groupReducer,
  dronState: dronReducer,
  authState: authReducer,
  accountState: accountReducer,
  UserPageState: mypageReducer,
  UserPwState: userPwReducer,
  controlGpState: controlGpReducer,
  controlGpHisState: controlGpHisReducer,
  controlGpLogState: controlGpLogReducer,
  controlGpDtlState: controlGpDtlReducer,
  controlGpCountState: controlGpCountReducer,
  // controlGroupAuthState: controlGroupAuthReducer,
  controlGpFltPlanState: controlGpFltPlanReducer,
  menuState: menuReducer,
  analysisHistoryState: analysisHistoryReducer,
  analysisSimulatorState: analysisSimulatorReducer,
  ControlGpWeatherState: controlGpReducer,
  flightState: flightReducer,
  findState: findAccountReducer
});

export default rootReducer;
